import { Card } from '@avanta/shared/components/ui/Card';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { UserCog } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { insuredPersonProfileForm } from './model';

const FIELD_IDS = [...Object.keys(insuredPersonProfileForm), 'healthCenter'];

export const InsuredPersonProfileFormSkeleton = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Card
      variant="primary"
      title={t('InsuredPersonsProfile.info.heading')}
      icon={UserCog}
      className="am-md:p-0"
      aria-busy="true"
    >
      <div className="flex flex-col" aria-hidden="true">
        <div className="grid grid-cols-3 gap-6 px-8 pt-8 pb-6">
          {FIELD_IDS.map(id => (
            <div key={id} className="flex flex-col gap-2">
              <Skeleton className="h-3.5 w-24" />
              <Skeleton className="h-10 w-full rounded-lg" />
            </div>
          ))}
        </div>
        <div className="flex justify-end py-2 px-4">
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
    </Card>
  );
};
